import React, { useState } from 'react';

const initialDrivers = [
  { name: 'Star TSP100III', url: 'https://starmicronics.com/support/products/tsp100iii-support-page/' },
  { name: 'Epson TM-T20II', url: 'https://download.epson-biz.com/modules/pos/index.php?page=single_soft&cid=6280' },
  { name: 'Bixolon SRP-350III', url: 'https://www.bixolon.com/html/en/download/download_product.xhtml?prod_id=33' },
  { name: 'Star TSP143III', url: 'https://www.starmicronics.com/printer/tsp100iii/' },
  { name: 'Epson TM-T88V', url: 'https://download.epson-biz.com/modules/pos/index.php?page=single_soft&cid=4110' },
  { name: 'Star TSP650II', url: 'https://www.starmicronics.com/printer/tsp650ii/' },
  { name: 'Bixolon XD5-40d', url: 'https://www.bixolon.com/html/en/download/download_product.xhtml?prod_id=74' },
  { name: 'Citizen CT-S310II', url: 'https://www.citizen-systems.com/en/printer/support/software-download/printer/citizen-ct-s310ii/' },
  { name: 'Star mC-Print3', url: 'https://www.starmicronics.com/printer/mc-print3/' },
  { name: 'Epson TM-T82III', url: 'https://download.epson-biz.com/modules/pos/index.php?page=single_soft&cid=6283' },
];

const PrinterDriverList = () => {
  const [drivers, setDrivers] = useState(initialDrivers);
  const [newDriver, setNewDriver] = useState({ name: '', url: '' });

  const handleAddDriver = () => {
    if (!newDriver.name || !newDriver.url) return alert('Please enter both name and URL');
    setDrivers([...drivers, newDriver]);
    setNewDriver({ name: '', url: '' });
  };

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div style={styles.container}>
      <h2>Printer Driver Downloads</h2>

      {drivers.map((driver, index) => (
        <div key={index} style={styles.driverCard}>
          <span>{driver.name}</span>
          <button style={styles.button} onClick={() => handleDownload(driver.url)}>
            Download
          </button>
        </div>
      ))}

      <div style={styles.addSection}>
        <h3>Add Your Printer Driver</h3>
        <input
          type="text"
          placeholder="Printer Name"
          value={newDriver.name}
          onChange={(e) => setNewDriver({ ...newDriver, name: e.target.value })}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Driver URL"
          value={newDriver.url}
          onChange={(e) => setNewDriver({ ...newDriver, url: e.target.value })}
          style={styles.input}
        />
        <button onClick={handleAddDriver} style={styles.addButton}>
          Add Driver
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial',
  },
  driverCard: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #ccc',
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  addSection: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #ccc',
  },
  input: {
    width: '100%',
    marginBottom: '10px',
    padding: '8px',
    fontSize: '14px',
  },
  addButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    fontSize: '14px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default PrinterDriverList;
